import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { LogOut, Sun, Moon, ChevronDown, User } from 'lucide-react';
import GalleryGrid from '../components/GalleryGrid';

const HomePage: React.FC = () => {
  const navigate = useNavigate();
  const [isDark, setIsDark] = useState(true);
  const [isAdminMenu, setIsAdminMenu] = useState(false);

  useEffect(() => {
    document.documentElement.classList.toggle('dark', isDark);
    localStorage.setItem('theme', isDark ? 'dark' : 'light');
  }, [isDark]);

  useEffect(() => {
    const savedTheme = localStorage.getItem('theme') || 'dark';
    setIsDark(savedTheme === 'dark');
  }, []);

  const toggleTheme = () => setIsDark(!isDark);
  const toggleAdminMenu = () => setIsAdminMenu(!isAdminMenu);

  return (
    <div className={`min-h-screen ${isDark ? 'dark bg-darkbg-900 text-white' : 'bg-gray-50 text-gray-900'} transition-all duration-300`}>
      {/* ✅ FIXED Header - Proper Layout */}
      <header className="bg-white/95 dark:bg-darkbg-800/95 backdrop-blur-xl border-b border-gray-200/50 dark:border-fgray-700/50 sticky top-0 z-50">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex items-center justify-between h-14 sm:h-16">
            {/* ✅ Left: Logo (Proper spacing) */}
            <div className="flex items-center gap-3">
              <div className="w-10 h-10 sm:w-11 sm:h-11 bg-gradient-to-r from-facebook-600 to-blue-600 rounded-2xl flex items-center justify-center shadow-lg flex-shrink-0">
                <User className="w-6 h-6 sm:w-7 sm:h-7 text-white" />
              </div>
              <h1 className="text-1xl sm:text-1xl font-black bg-gradient-to-r from-facebook-600 to-blue-600 bg-clip-text text-transparent hidden sm:block">
                Aarya's World
              </h1>
              <span className="text-xl font-bold text-facebook-600 sm:hidden">Aarya's World</span>
            </div>

            {/* ✅ Right: Actions (Proper spacing) */}
            <div className="flex items-center gap-2 sm:gap-3">

                 {/* Theme Toggle */}
              <button
                onClick={toggleTheme}
                className="w-11 h-11 rounded-2xl bg-gray-200/50 dark:bg-fgray-700/50 hover:bg-gray-300/70 dark:hover:bg-fgray-600 flex items-center justify-center transition-all shadow-md hover:shadow-lg flex-shrink-0"
                title={isDark ? 'Light mode' : 'Dark mode'}
              >
                {isDark ? <Sun className="w-5 h-5" /> : <Moon className="w-5 h-5" />}
              </button>
              {/* Admin Button */}
              <div className="relative">
                <button
                  onClick={toggleAdminMenu}
                  className="flex items-center gap-2 px-4 py-2 bg-facebook-600 hover:bg-facebook-700 text-white font-semibold rounded-2xl shadow-lg hover:shadow-facebook-500/25 transition-all min-h-[44px] text-sm sm:text-base"
                >
                  Menu
                  <ChevronDown className={`w-4 h-4 transition-transform ${isAdminMenu ? 'rotate-180' : ''}`} />
                </button>

                {/* ✅ FIXED Dropdown - Proper positioning */}
                {isAdminMenu && (
                  <div className="absolute right-0 top-full mt-2 bg-white/95 dark:bg-darkbg-800/95 backdrop-blur-xl border border-gray-200/50 dark:border-fgray-700/50 rounded-2xl shadow-2xl py-2 w-48 z-50 animate-in fade-in slide-in-from-top-2 duration-200">
                    <a
                      href="/admin"
                      className="flex items-center gap-3 px-6 py-3 text-gray-900 dark:text-white hover:bg-gray-100/50 dark:hover:bg-fgray-700/50 rounded-xl transition-all font-medium"
                      onClick={() => setIsAdminMenu(false)}
                    >
                      Dashboard
                    </a>
                  </div>
                )}
              </div>

             
            </div>
          </div>
        </div>
      </header>

      <main className="pb-6 sm:pb-12">
        <GalleryGrid />
      </main>
    </div>
  );
};

export default HomePage;
